import { render } from "./filter.modules.vue?vue&type=template&id=363874e6&ts=true"
import script from "./filter.modules.vue?vue&type=script&lang=ts"
export * from "./filter.modules.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__